import React, { useEffect, useState } from "react";
import styled from "styled-components";
import OrdersList from "../../../components/Orders/OrdersList";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as OrdersActions from "../../../store/actions/Orders";
import { Heading } from "../../../constants/assets/containers";

const statesToReset = [
  "filters",
  "ordersList",
  "ordersCount",
  "nextPage",
  "prevPage",
];

const Index = ({
  getOrdersCount,
  getOrdersList,
  ordersCount,
  ordersList,
  filters,
  resetState,
}) => {
  useEffect(() => {
    var stateCountMapping = {};
    var atLeastOneValPresent = "";
    for (var i = 0; i < ordersList.length; i++) {
      var order = ordersList[i];
      var state = order.order_state;

      if (state in stateCountMapping) {
        stateCountMapping[state]++;
      } else {
        stateCountMapping[state] = 1;
      }
      atLeastOneValPresent = state;
    }
  }, [ordersList]);

  const applyFilters = (filters, orderState, noActiveFilters) => {
    let newFilters = { ...filters };
    newFilters["page"] = 1;
    delete filters.page;
    getOrdersList(newFilters);
    if (!orderState) {
      getOrdersCount(filters).then((res) => {});
    }
  };

  const clearFilters = () => {
    statesToReset.forEach((state) => resetState(state));
  };

  const getFilters = () => {
    const updatedObj = { ...filters };
    delete updatedObj.page;
    return updatedObj;
  };

  return (
    <OrdersView>
      <Heading>Orders</Heading>
      <OrdersList
        clearFilters={clearFilters}
        list={ordersList}
        applyFilters={applyFilters}
        allFilters={getFilters()}
      />
    </OrdersView>
  );
};

const OrdersView = styled.section`
  height: unset;
`;

function mapStateToProps(state) {
  const { Orders } = state;
  return {
    ordersList: Orders.OrdersList,
    filters: Orders.Filters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getOrdersList: bindActionCreators(OrdersActions.getOrdersList, dispatch),
    resetState: bindActionCreators(OrdersActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
